import React from "react";
import axios from "axios";
import AttendeeView from "./AttendeeView";
import CalibrationView from "./CalibrationView";
import "./styles/MeetingIDInput.css";

class MeetingIDInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attendeeId: -1,
      meetingConfirmed: false,
      meetingID: "",
      name:""
    };
  }

  handleChange = (event) => {
    this.setState({ meetingID: event.target.value });
  };

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  };

  handleSubmit = (event) => {
    console.log(this.state.name);
    let idPostPromise = axios.post(
      `http://144.126.212.184:8000/postMeetingID/${this.state.meetingID}`,
      {name: this.state.name}
    );
    idPostPromise.then(
      (res) => {
        let attendeeId = res.data;
        if (attendeeId !== "NONEXIST") {
          this.setState({
            attendeeId: attendeeId,
          });
        } else {
          alert("Meeting doesn't exist, please try again!");
        }
      },
      (error) => {
        console.log("got error");
        console.log(error);
      }
    );
    event.preventDefault();
  };

  render() {
    return (
      <div>
        {this.state.attendeeId === -1 ? (
          <div id="meetingIDInputFrom">
            <form onSubmit={this.handleSubmit}>
              <label>
                <input
                  type="text"
                  value={this.state.meetingID}
                  onChange={this.handleChange}
                  placeholder="Meetind ID"
                  id="meetingIDInput"
                />
              </label>
              <label>
                <input
                  type="text"
                  value={this.state.name}
                  onChange={this.handleNameChange}
                  placeholder="Name (for the interview)"
                  id="nameInput"
                />
              </label>
              <input type="submit" value="Submit" id="submitButton" />
            </form>
          </div>
        ) : (
          <CalibrationView
            attendeeId={this.state.attendeeId}
            meetingId={this.state.meetingID}
          />
        )}
      </div>
    );
  }
}

export default MeetingIDInput;
